import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Login from './components/Login/Login';
import LoginCallback from './components/Login/LoginCallback';
import Verifier from './components/Verifier/Verifier';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import "./App.css";

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <div className="app-container">
          <Navbar />
          <div className="main-container">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/login/callback" element={<LoginCallback />} />

              <Route
                path="/verifier"
                element={
                  <ProtectedRoute>
                    <Verifier />
                  </ProtectedRoute>
                }
              />

              <Route path="/" element={<Navigate to="/verifier" replace />} />
              <Route path="*" element={<Navigate to="/verifier" replace />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;
